import React from "react";
import { useFormContext } from "react-hook-form";
import { StyledCell, StyledWorkOrderStack } from "../styles";
import WorkOrderSelectField from "../WorkOrderSelectField";

const WorkOrderTableAddRow = ({
  handleWorkOrderAdd = () => {},
  disabled,
  options = [],
}) => {
  const prefix = "workaddrow";

  const { getValues, setValue } = useFormContext();

  const onFieldUpdate = (field) => {
    const value = getValues(`${prefix}.${field}`);
    handleWorkOrderAdd({ [field]: value });
    setValue(prefix, {});
  };

  return (
    <StyledWorkOrderStack highlight="true">
      <WorkOrderSelectField
        name={`${prefix}.workOrderId`}
        value={null}
        options={options}
        onChange={() => onFieldUpdate("workOrderId")}
        placeholder="Add Work Order"
        disabled={disabled}
      />
      <StyledCell highlight="true" />
      <StyledCell highlight="true" />
      <StyledCell highlight="true" />
      <StyledCell highlight="true" />
    </StyledWorkOrderStack>
  );
};

export default WorkOrderTableAddRow;
